import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect, selectSplitInit } from '@socialive/common';
import baseEffect from './effect';

export const effect = createListenerEffect('features/updateSplitConstOnInit<Listener>', baseEffect, { once: true });

export const predicate = (action, state) => !!selectSplitInit(state);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  predicate,
  effect,
});

export default middleware;
